import { useMutation } from "@tanstack/react-query";
import { postApplication } from "app/api/application_api";

export const usePostApplication = ({ onSuccess, onError = () => { }, onApply = () => { } }) => {
  return useMutation({
    mutationFn: (application) => {
      console.log("usePostApplication - Application data:", application);
      onApply();
      return postApplication(application);
    },
    onSuccess: (data) => {
      console.log("usePostApplication - Success:", data);
      onSuccess(data);
    },
    onError: (error) => {
      console.error("usePostApplication - Error:", error);
      onError(error);
    }
  });
};
